module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0059.jpg?v=b3e82db1";